<template>
  <Layout>
    <div class="row mb-4" style="align-items: center">
      <div class="col-9">
        <h4 class="mb-0 font-size-18">{{ title }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8">
                <h4 class="card-title mb-4" style="display: flex; gap: 10px; align-items: center">Logs
                  <span>
                    <button type="button" @click="goBack()" class="link btn btn-outline-dark btn-sm ml-10">Voltar</button>
                  </span>
                </h4>
              </div>
              <div class="col-sm-4">
                <div class="search-box mr-2 mb-2">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Pesquise por Nome ou Telefone e pressione 'ENTER'" @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap">
                <thead>
                  <tr>
                    <th width="5%">#</th>
                    <th width="10%">Data</th>
                    <th width="40%">Participante</th>
                    <th width="40%">Detalhes</th>
                    <th width="5%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, idx) in contacts" :key="idx">
                    <td>{{ `# ${idx + 1}` }}</td>
                    <td>{{ list.created_at }}</td>
                    <td>{{ (list.participant && list.participant.data && list.participant.data.name) || '—' }}</td>
                    <td>{{ list.detail }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@/components/layout/vertical'
import appConfig from '@/app.config'
// import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Layout
  },
  name: 'task-tags-details',
  page: {
    title: 'Tarefas - Logs da Tarefa',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      timeout: 60000,
      search: '',
      showLog: false,
      logMessage: {
        body: null
      },
      params: {
        include: 'logs'
      },
      campaign: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      submitted: false,
      title: 'Logs da Tarefa -',
      items: [{
        text: 'Tarefas'
      },
      {
        text: 'Listagem',
        active: true
      }
      ]
    }
  },
  mounted () {
    this.loadItem()
    this.loading = false
  },
  computed: {
    ...mapState('taskTag', { data: 'tasktag' }),
    ...mapState('taskTag', ['contacts', 'paginationC']),
    rows () {
      return this.paginationC.total
    }
  },
  methods: {
    ...mapActions('taskTag', {
      getTaskTag: 'show',
      getContacts: 'getContacts'
    }),
    goBack () {
      this.$router.push({
        name: 'setting-tasks'
      })
    },
    loadItem () {
      if (this.$route.params.id !== undefined) {
        let loader = this.$loading.show()
        // this.getCampaignContacts()
        this.getTaskTag(this.$route.params.id)
          .then(() => {
            this.title += ' ' + this.data.name
            this.tasktag = this.data
          }).then(() => {
            loader.hide()
            this.updateList()
          })
      }
    },
    getReport (filter) {
      let params = {
        include: 'participant',
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      let loeader = this.$loading.show()
      this.params = params
      this.getContacts({ id: this.tasktag.id, params: this.params }).then(() => {
        this.totalRows = this.paginationC.total
        this.currentPage = this.paginationC.current_page
        loeader.hide()
      }).catch(error => {
        loeader.hide()
        console.log(error)
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
      // this.$refs.child.getSubscribers()
    }
  },
  watch: {
    // currentPage () { this.updateList() }
    // total () { this.updateList() },
  }
}
</script>
<style scoped>
.log-message {
  padding: 10px 5px 10px 30px;
  background: #f5f5f5;
  display: flex;
  justify-content: right;
}
.infos {
  padding: 30px 25px;
}
.infos .info:not(:last-child) {
  margin-bottom: 20px;
  border-bottom: 1px solid #e8e9ed;
  padding-bottom: 20px;
}
.textinfo {
  line-height: 26px;
  font-size: 14px;
}
.infos .info .title {
  display: flex;
  align-items: center;
}
.infos .info .title .icon {
  display: flex;
  margin-right: 6px;
  width: 15px;
  justify-content: center;
  flex-shrink: 0;
}
.infos .info .title .icon svg {
  display: block;
  fill: #a2a7b6;
}
.infos .info .title .icon svg.failed, .infos .info .title .icon svg.sent {
  width: 11px;
  height: 8px;
}
.infos .info .title .icon svg.read {
  fill: #3774d0;
}
.infos .info .title .icon svg.failed {
  fill: #d03737;
}
.link { cursor: pointer; }
.inativado { background: #f7ebeb }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px;}
.float-sm-end { float: right }
</style>
